import React from "react";
// import { Link } from 'gatsby';

import {
  Card,
  CardHeader,
  CardBody,
  // Button,
  CardTitle,
  CardText
  // CardImg
} from "reactstrap";

import BromleyCarousel from "../components/bromleyCarousel";
import CheltenhamCarousel from "../components/cheltenhamCarousel";
import CamberwellCarousel from "../components/camberwellCarousel";
import TCRCarousel from "../components/TCRCarousel";

import ImagesStripRetail from "../components/ImagesStripRetail";

import Layout from "../components/layout";
import SEO from "../components/seo";

const RetailPage = () => (
  <Layout>
    <SEO title="Retail" />
    <div className="container">
      <h1 className="d-block text-center display-3">Retail</h1>
      <div className="d-block text-center mt-3">
        <p className="lead">
          With our experience in the retail sector we are used to working to
          tight deadlines, on tricky sites and around trading stores. Time and
          again we deliver high quality projects to the budget we have agreed.
        </p>
      </div>
      <ImagesStripRetail />

      <hr />
      <div id="projects">
        <h3 className="d-block text-center">Recent Retail Projects.</h3>

        <Card className="m-5">
          <CardHeader>
            Retail Supermarket - Tottenham Court Road - Central London
          </CardHeader>
          <CardBody>
            <CardTitle>
              <strong>
                An exciting new retail supermarket in the heart of London.
              </strong>
            </CardTitle>
            <CardText>
              CURRENTLY IN PROGRESS ONSITE! <br />
              <br />
              Coming Soon - Watch this space for updates!!
            </CardText>
            <CardText>
              <small className="text-muted">Updated 29.02.20</small>
            </CardText>
            <br />

            <div className="mx-4 mb-4">
              <TCRCarousel />
            </div>
          </CardBody>
        </Card>

        <Card className="m-5">
          <CardHeader>Retail Supermarket - Camberwell</CardHeader>
          <CardBody>
            <CardTitle>
              <strong>
                Fit out of a unique retail space to form a new retail
                supermarket
              </strong>
            </CardTitle>
            <CardText>
              High street retail store <br />
              <br />
              Works included, partitioning, joinery, ceilings, ceramic floor
              tiling, formation of warehouse and welfare areas and complete M&E
              installations.
            </CardText>
            <CardText>
              <small className="text-muted">Updated 28.11.19</small>
            </CardText>
            <br />

            <div className="mx-4 mb-4">
              <CamberwellCarousel />
            </div>
          </CardBody>
        </Card>

        <Card className="m-5">
          <CardHeader>Retail Supermarket - Bromley</CardHeader>
          <CardBody>
            <CardTitle>
              <strong>
                Strip out and fit out of a former BHS Store to form a new retail
                supermarket
              </strong>
            </CardTitle>
            <CardText>
              With works carried out over 5 floors and limited access, this
              pedestrianised high street fronting site was a tricky and
              challenging site. <br />
              <br />
              Works included strip out of the existing store, removal of
              escalators, structural steel works, infilling of concrete floor
              slabs, installation of new passenger and cargo lifts,
              partitioning, new shopfront, autodoors, cladding, joinery,
              ceilings, ceramic floor tiling, formation of warehouse and welfare
              areas and complete M&E installations.
            </CardText>
            <CardText>
              <small className="text-muted">Updated 10.07.19</small>
            </CardText>
            <br />

            <div className="mx-4 mb-4">
              <BromleyCarousel />
            </div>
          </CardBody>
        </Card>

        <Card className="m-5">
          <CardHeader>Retail Supermarket - Cheltenham</CardHeader>
          <CardBody>
            <CardTitle>
              <strong>
                Fit out of purpose built developer shell to form a new retail
                supermarket
              </strong>
            </CardTitle>
            <CardText>
              The project was a fit out of a purpose built retail unit to form a
              new retail supermarket. <br />
              <br />
              Works included formation of new external terrace, partitioning,
              autodoors, joinery, ceilings, ceramic floor tiling, rendering,
              painting, formation of welfare areas and complete M&E
              installations.
            </CardText>
            <CardText>
              <small className="text-muted">Updated 10.07.19</small>
            </CardText>
            <br />
            <div className="mx-4 mb-4">
              <CheltenhamCarousel />
            </div>
          </CardBody>
        </Card>
      </div>
    </div>
  </Layout>
);

export default RetailPage;
